/**
 * Created by Tomás
 * 
 * Esse fix foi necessário para resolver a issue SDAPPECAS-740.
 * 
 */
(function(angular){
    "use strict";

    var NUM_EXTRA = 3;

    angular.module("md-virtual-repeat-scroll-fix", [])
    .config(["$provide", function($provide) {
        $provide.decorator('mdVirtualRepeatContainerDirective', function($delegate, $interval) {
            var directive = $delegate[0];
            var originalCompile = directive.compile;
            var originalCtrl = directive.controller;
            /**
             * Trouxe parte da implementação alterada no seguinte commit https://github.com/angular/material/commit/3cf4d7440289187ff57f1f341ec78c15941141d4
             * É possível que essa alteração corrija o bug.
             */
            originalCtrl.prototype.handleScroll_ = function() {
                var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
                if(!ltr && !this.maxSize) {
                  this.scroller.scrollLeft = this.scrollSize;
                  this.maxSize = this.scroller.scrollLeft;
                }
                var offset = this.isHorizontal() ?
                    (ltr?this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
                    : this.scroller.scrollTop;
                if (this.scrollSize < this.size) return;
                if (offset > this.scrollSize - this.size) {
                    offset = this.scrollSize - this.size;
                }
                if (offset === this.scrollOffset) return;
              
                var itemSize = this.repeater.getItemSize();
                if (!itemSize) return;
              
                var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);
              
                var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
                    (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';
              
                this.scrollOffset = offset;
                this.offsetter.style.webkitTransform = transform;
                this.offsetter.style.transform = transform;
              
                if (this.bindTopIndex) {
                  var topIndex = Math.floor(offset / itemSize);
                  if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
                    this.topIndex = topIndex;
                    this.bindTopIndex.assign(this.$scope, topIndex);
                    if (!this.$rootScope.$$phase) this.$scope.$digest();
                  }
                }
              
                this.repeater.containerUpdated();
            };

            /**
             * Aparentemente, dependendo do momento em que o scroll é feito,
             * pode ser que o cálculo de quais itens devem ser exibidos fique
             * errado. Desse modo, é necessário forçar a atualização desse
             * cálculo a cada 100ms. Isso está ativável condicionalmente para
             * podermos validar se realmente é necessário ou não.
             */
            directive.compile = function virtualRepeatContainerCompile($element, $attrs) {
                originalCompile.call(this, $element, $attrs);
                return function(scope, element, attrs, ctrl) {
                    if (window.forceVirtualRepeatContainerUpdate) {
                        var stop = $interval(function() {
                            ctrl.repeater.containerUpdated();
                        }, 100);
                        scope.$on("$destroy", function() {
                            $interval.cancel(stop);
                        });
                    }

                    if (window.forceVirtualRepeatContainerUpdateAndHandleScroll) {
                        var stop = $interval(function() {
                            ctrl.handleScroll_();
                            ctrl.repeater.containerUpdated();
                        }, 100);
                        scope.$on("$destroy", function() {
                            $interval.cancel(stop);
                        });
                    }
                };
            };
            
            return $delegate;
        });
    }]);

})(angular);
